import { req } from '@/apis/https';

const featureAccessBase = ogzuid =>
	'/portal/organizer/' + ogzuid + '/feature-access';

// 載入 Organizer EMS 完整功能目錄與帳號開通狀態。
export const apiLoadOrganizerFeatureAccessMenu = (ogzuid, params) =>
	req('get', featureAccessBase(ogzuid) + '/menu', params);

// 檢查指定功能頁面是否允許進入；ogzuid 以 path 傳入，身份由 req() 的 payload header 帶入。
export const apiCheckOrganizerFeatureAccess = (ogzuid, funcid, params) =>
	req(
		'get',
		featureAccessBase(ogzuid) + '/check/' + encodeURIComponent(funcid),
		params
	);
